import {
    IState
} from './friends-referral-store.types';
import {
    FRIENDS_REFERRAL_SET_LOADING,
    FRIENDS_REFERRAL_SET_ERROR,
    FRIENDS_REFERRAL_SET_PLATFORMS_OWNERSHIP,
    FRIENDS_REFERRAL_SET_REGISTERED_REFERRER_INFO,
    FRIENDS_REFERRAL_SET_PLAYER_INFO,
    FRIENDS_REFERRAL_SUCCESS_CAMPAIGN_STATUS,
    FRIENDS_REFERRAL_FAIL_CAMPAIGN_STATUS,
    FRIENDS_REFERRAL_MAINTENANCE_CAMPAIGN_STATUS,
    FRIENDS_REFERRAL_SET_CAMPAIGN_INFO,
    FRIENDS_REFERRAL_SET_INVITATION_INFO,
    FRIENDS_REFERRAL_SET_PLAYER_STATS,
    FRIENDS_REFERRAL_SHOW_REWARDS_IMAGE_LIGHTBOX
} from './friends-referral-store.constants';
import { Actions as FriendReferralStoreActions } from './friends-referral-store.actions';

export const initial: IState = {
    loading: false,
    error: null,
    platformsOwnership: null,
    invitationInfo: null,
    playerStats: null,
    rewardsImageLightboxOpened: false
};

/** Reducer for storing player referral information and related request statuses (loading, error, etc.) */
const friendsReferral = (state: IState = initial, action: FriendReferralStoreActions): IState => {
    switch (action.type) {
    case FRIENDS_REFERRAL_SET_LOADING:
        return { ...state, loading: action.loading, error: null };
    case FRIENDS_REFERRAL_SET_ERROR:
        return { ...state, error: action.error, loading: false };
    case FRIENDS_REFERRAL_SET_PLATFORMS_OWNERSHIP:
        return { ...state, loading: false, error: null, platformsOwnership: action.platformsOwnership };
    case FRIENDS_REFERRAL_SET_REGISTERED_REFERRER_INFO:
        return {
            ...state,
            platformsOwnership: {
                ...state.platformsOwnership,
                [action.platform]: true
            },
            playerInfo: {
                isReferrer: state.playerInfo!.isReferrer,
                isConverted: state.playerInfo!.isConverted,
                invitationId: action.invitationId
            }
        };
    case FRIENDS_REFERRAL_SET_PLAYER_INFO:
        return { ...state, loading: false, error: null, playerInfo: action.playerInfo };
    case FRIENDS_REFERRAL_SUCCESS_CAMPAIGN_STATUS:
    case FRIENDS_REFERRAL_FAIL_CAMPAIGN_STATUS:
    case FRIENDS_REFERRAL_MAINTENANCE_CAMPAIGN_STATUS:
        return { ...state, loading: false, error: null };
    case FRIENDS_REFERRAL_SET_CAMPAIGN_INFO:
        return { ...state, loading: false, error: null, campaignInfo: action.campaignInfo };
    case FRIENDS_REFERRAL_SET_INVITATION_INFO:
        return { ...state, loading: false, error: null, invitationInfo: action.invitationInfo };
    case FRIENDS_REFERRAL_SET_PLAYER_STATS:
        return { ...state, loading: false, error: null, playerStats: { ...state.playerStats, ...action.playerStats } };
    case FRIENDS_REFERRAL_SHOW_REWARDS_IMAGE_LIGHTBOX:
        return { ...state, rewardsImageLightboxOpened: action.payload };
    default:
        return state;
    }
};
export const reducerKey: string = 'friendsReferral';
export default friendsReferral;
